import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CmsHeadTags, CmsContainerPage, CmsPageLayout } from '@grandvisionhq/bloomreach';
import { ErrorPage } from '@grandvisionhq/layout';

const withErrorPage = (errorProps)=>(PageComponent)=>{
        const WithErrorPage = (props)=>{
            const { buttonText , image , subheader , title  } = errorProps || props;
            const { statusCode  } = props;
            if (statusCode && statusCode >= 400) {
                // If we receive a 404, we can assume that we still have a pagemodel, so we want to return the header and footer as well
                if (statusCode === 404) {
                    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsHeadTags, {
                        title: title,
                        noIndex: true,
                        noFollow: true
                    }), /*#__PURE__*/ React.createElement(CmsContainerPage, null, /*#__PURE__*/ React.createElement(CmsPageLayout, null, /*#__PURE__*/ React.createElement(ErrorPage, {
                        header: title,
                        buttonText: buttonText,
                        image: image,
                        subheader: subheader
                    }))));
                }
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsHeadTags, {
                    title: title,
                    noIndex: true,
                    noFollow: true
                }), /*#__PURE__*/ React.createElement(ErrorPage, {
                    header: title,
                    buttonText: buttonText,
                    image: image,
                    subheader: subheader
                }));
            }
            return /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, props));
        };
        WithErrorPage.getInitialProps = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(ctx) {
                const pageProps = (PageComponent.getInitialProps ? yield PageComponent.getInitialProps(ctx) : null) || {};
                if (pageProps.statusCode && ctx.res) {
                    ctx.res.statusCode = pageProps.statusCode;
                }
                return pageProps;
            });
            return function(ctx) {
                return _ref.apply(this, arguments);
            };
        }();
        WithErrorPage.displayName = `WithErrorPage(${PageComponent.displayName || PageComponent.name || 'Unknown'})`;
        return WithErrorPage;
    }
;
var withErrorPage$1 = withErrorPage;

export { withErrorPage$1 as default };
//# sourceMappingURL=with-error-page.js.map
